import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import * as z from "zod";

export const getProductsForShopifyVariants = {
  name: "getProductsForShopifyVariants" as const,
  input: z.object({ shopifyVariantIds: z.array(z.string()).max(500) }),
  output: z.object({
    items: z.array(
      z.object({
        shopifyVariantId: z.string(),
        productId: productIdFormat.schema,
        productFamilyId: productFamilyIdFormat.schema,
      }),
    ),
  }),
};
